<template>
    <div>
        <div class="title__rank">
            <span v-html="t.earnings"></span>
            <span class="helper__tooltip">
                <span
                    v-html="t.label_tooltip_earnings"
                    class="helper__tooltip--text"
                ></span>
            </span>
        </div>
        <div class="card-v4 container__grid">
            <div class="options">
                <a
                    v-show="!loading"
                    @click="handleData('THIS_MONTH')"
                    class="js-btn__opt"
                >{{t.this_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleData('LAST_MONTH')"
                    class="js-btn__opt"
                >{{t.last_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleData('LAST_3_MONTH')" 
                    class="js-btn__opt"
                >{{t.last_3_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleData('LAST_6_MONTH')"
                    class="js-btn__opt"
                >{{t.last_6_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleData('ALL_TIME')"
                    class="js-btn__opt"
                >{{t.all_time}}</a>
                <div class="animation__loading" v-show="loading"></div>
            </div>
            <div class="earnings">
                <h4>{{t.all_earnings}}</h4>
                <div class="box__in">
                    <div class="body">
                        <div class="body__leads">
                            <div>
                                <span>{{t.all_leads}}</span>
                                <span>{{first.leads}}</span>
                            </div>
                            <div>
                                <span>{{t.all_active_leads}}</span>
                                <span>{{first.active_leads}}</span>
                            </div>
                            <div>
                                <span>{{t.number_of_all_affiliates}}</span>
                                <span>{{first.affiliates}}</span>
                            </div>
                        </div>
                        <div class="body__values">
                            <div>
                                <span>USD</span> 
                                <span>$ {{first.usd}}</span>
                            </div>
                            <div>
                                <span>EUR</span>
                                <span>€ {{first.eur}}</span>
                            </div>
                            <div>
                                <span>BRL</span>
                                <span>R$ {{first.brl}}</span>
                            </div>
                            <!-- <div>
                                <span>BTC</span>
                                <span class="btc__icon">{{first.btc}}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="tier">
                <h4>{{t.first_tier_leads}}</h4>
                <div class="box__in">
                    <div class="body">
                        <div class="body__leads">
                            <div>
                                <span>{{t.all_leads}}</span>
                                <span>{{second.leads}}</span>
                            </div>
                            <div>
                                <span>{{t.all_active_leads}}</span>
                                <span>{{second.active_leads}}</span>
                            </div>
                            <div>
                                <span>{{t.number_of_all_affiliates}}</span>
                                <span>{{second.affiliates}}</span>
                            </div>
                        </div>
                        <div class="body__values">
                            <div>
                                <span>USD</span>
                                <span>$ {{second.usd}}</span>
                            </div> 
                            <div>
                                <span>EUR</span>
                                <span>€ {{second.eur}}</span>
                            </div>
                            <div>
                                <span>BRL</span>
                                <span>R$ {{second.brl}}</span>
                            </div>
                            <!-- <div>
                                <span>BTC</span>
                                <span class="btc__icon">{{second.btc}}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="tier tier__indirect"> -->
            <div class="tier">
                <h4>
                    <!-- {{t.second_tier_leads}} - {{selectedLevel}} -->
                    <!-- {{selectedLevel}} -->
                    {{t.tier_2_sales}}
                    <!-- <div class="select__level">
                        <span
                            @click="handleData(null, 1, 100, true)"
                            class="js-btn__opt__type active"
                        >{{t.label_all}}</span>
                        <span
                            @click="handleData(null, 1, 1, true)"
                            class="js-btn__opt__type"
                        >{{t.level}} 1</span>
                        <span
                            @click="handleData(null, 2, 2, true)"
                            class="js-btn__opt__type"
                        >{{t.level}} 2</span>
                        <span
                            @click="handleData(null, 3, 3, true)"
                            class="js-btn__opt__type"
                        >{{t.level}} 3</span>
                        <span
                            v-if="isAmbassador"
                            @click="handleData(null, 4, 100, true)"
                            class="js-btn__opt__type"
                        >{{t.level}} 4+</span>
                    </div> -->
                </h4>
                <div class="box__in">
                    <div class="body">
                        <div class="body__leads">
                            <div>
                                <span>{{t.all_leads}}</span>
                                <span>{{third.leads}}</span>
                            </div>
                            <div>
                                <span>{{t.all_active_leads}}</span>
                                <span>{{third.active_leads}}</span>
                            </div>
                            <div>
                                <span>{{t.number_of_all_affiliates}}</span>
                                <span>{{third.affiliates}}</span>
                            </div>
                        </div>
                        <div class="body__values">
                            <div>
                                <span>USD</span>
                                <span>$ {{third.usd}}</span>
                            </div>
                            <div>
                                <span>EUR</span>
                                <span>€ {{third.eur}}</span>
                            </div>
                            <div>
                                <span>BRL</span>
                                <span>R$ {{third.brl}}</span>
                            </div>
                            <!-- <div>
                                <span>BTC</span>
                                <span class="btc__icon">{{third.btc}}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "all-values-user",
    props: ["props"],
    components: {},
    data() {
        return {
            allValues: {},
            t: this.$parent.view.translation.allValuesUser,
            allData: this.$parent.view.dashboard_values_v3.all_values,
            loading: false,
            currentTime: "ALL_TIME",
            currentStartLevel: 0,
            currentEndLevel: 0,
            firstRound: false,
            whichBtnTypeIsActive: 0,
            hostMicroservice: window.__env.microservices.bucket.host, 
            // selectedLevel: this.$parent.view.translation.allValuesUser.label_all,
            selectedLevel: this.$parent.view.translation.allValuesUser.level + ' ' + 1,
            isAmbassador:
                this.$parent.view.IS_AMBASSADOR ||
                this.$parent.view.IS_AMBASSADOR_PLUS
                    ? true
                    : false,
            first: { 
                leads: 0,
                active_leads: 0,
                affiliates: 0,
                usd: 0,
                eur: 0,
                brl: 0,
                btc: 0
            },
            second: {
                leads: 0,
                active_leads: 0,
                affiliates: 0,
                usd: 0,
                eur: 0,
                brl: 0,
                btc: 0
            },
            third: {
                leads: 0,
                active_leads: 0,
                affiliates: 0,
                usd: 0,
                eur: 0,
                brl: 0,
                btc: 0
            }
        };
    },
    methods: {
        handleData(
            type = "ALL_TIME",
            levelStart = 0,
            levelEnd = 100,
            onlyLevel = false 
        ) {
            this.loading = true;
            let vm = this;
            let buttons = document.querySelectorAll(".js-btn__opt");
            // let buttons__type = document.querySelectorAll(".js-btn__opt__type");

            if(levelStart == 1) this.selectedLevel = this.t.level + ' ' + 1;
            if(levelStart == 2) this.selectedLevel = this.t.level + ' ' + 2;
            if(levelStart == 3) this.selectedLevel = this.t.level + ' ' + 3;
            if(levelStart == 4) this.selectedLevel = this.t.level + ' ' + 4 + '+';
            if(levelStart == 1 && levelEnd == 100) {
                this.selectedLevel = this.t.label_all;
            }
            this.selectedLevel = this.t.level + ' ' + 1
            
            // buttons__type[0].classList.contains("active")
            //     ? (this.whichBtnTypeIsActive = 0)
            //     : false;
            // buttons__type[1].classList.contains("active")
            //     ? (this.whichBtnTypeIsActive = 1)
            //     : false;
            // buttons__type[2].classList.contains("active")
            //     ? (this.whichBtnTypeIsActive = 2)
            //     : false;
            // if(this.isAmbassador) {
            //     buttons__type[3].classList.contains("active")
            //         ? (this.whichBtnTypeIsActive = 3)
            //         : false;
            // }
            // buttons__type[0].classList.remove("active");
            // buttons__type[1].classList.remove("active");
            // buttons__type[2].classList.remove("active");
            // buttons__type[3].classList.remove("active");
            // if(this.isAmbassador) buttons__type[4].classList.remove("active");
            //se nao for os botoes de 2tier
            if (!onlyLevel) {
                buttons[0].classList.remove("active");
                buttons[1].classList.remove("active");
                buttons[2].classList.remove("active");
                buttons[3].classList.remove("active");
                buttons[4].classList.remove("active");
                this.currentTime = type;
            }

            if (type == "ALL_TIME") buttons[4].classList.add("active");
            // if (!this.firstRound) buttons__type[0].classList.add("active"); 
            this.firstRound = true;
 
            fetch(
                `${this.hostMicroservice}/users/${this.$parent.view.dados_usuario_office.id}/level?start=${levelStart}&end=${levelEnd}&period=${this.currentTime}`,
                {
                    mode: "cors",
                    headers: {
                        Origin: "*"
                    }
                } 
            )
                .then(res => {
                    return res.text();  
                })
                .then(data => {
                    vm.loading = false;
                    this.allResponse = JSON.parse(data);
                    if (onlyLevel) {
                        this.currentStartLevel = levelStart;
                        this.currentEndLevel = levelEnd;
                        vm.third = {
                            leads: this.allResponse.leads,
                            active_leads: this.allResponse.activeLeads,
                            affiliates: this.allResponse.isAffiliate,
                            usd: this.allResponse.earningsUSD,
                            eur: this.allResponse.earningsEUR,
                            brl: this.allResponse.earningsBRL, 
                            btc: 0
                        };
                    } else {
                        vm.first = {
                            leads: this.allResponse.leads,
                            active_leads: this.allResponse.activeLeads,
                            affiliates: this.allResponse.isAffiliate,
                            usd: this.allResponse.earningsUSD,
                            eur: this.allResponse.earningsEUR,
                            brl: this.allResponse.earningsBRL,
                            btc: 0
                        }; 
                        vm.second = {
                            leads: this.allResponse.directLeads,
                            active_leads: this.allResponse.directActiveLeads,
                            affiliates: this.allResponse.directIsAffiliate,
                            usd: this.allResponse.directEarningsUSD,
                            eur: this.allResponse.directEarningsEUR,
                            brl: this.allResponse.directEarningsBRL,
                            btc: 0 
                        };
                        //para buscar o indiretos
                        fetch(
                            `${this.hostMicroservice}/users/${this.$parent.view.dados_usuario_office.id}/level?start=${vm.currentStartLevel}&end=${vm.currentEndLevel}&period=${vm.currentTime}`,
                            {
                                mode: "cors",
                                headers: {
                                    Origin: "*" 
                                }
                            }
                        )
                            .then(res => {
                                return res.text();
                            })
                            .then(data => {
                                this.allResponse = JSON.parse(data);
                                // buttons__type[
                                //     this.whichBtnTypeIsActive
                                // ].classList.add("active");
                                vm.third = { 
                                    leads: this.allResponse.leads,
                                    active_leads: this.allResponse.activeLeads,
                                    affiliates: this.allResponse.isAffiliate,
                                    usd: this.allResponse.earningsUSD,
                                    eur: this.allResponse.earningsEUR,
                                    brl: this.allResponse.earningsBRL,
                                    btc: 0
                                };
                            });
                    } 
                });
        }
    },
    mounted() {
        let buttons = document.querySelectorAll(".js-btn__opt");
        buttons[0].addEventListener("click", () => {
            event.target.classList.add("active");
        });
        buttons[1].addEventListener("click", () => {
            event.target.classList.add("active");
        });
        buttons[2].addEventListener("click", () => {
            event.target.classList.add("active"); 
        });
        buttons[3].addEventListener("click", () => {
            event.target.classList.add("active");
        });
        buttons[4].addEventListener("click", () => {
            event.target.classList.add("active");
        });
        // let buttons__type = document.querySelectorAll(".js-btn__opt__type");
        // buttons__type[0].addEventListener("click", () => {
        //     event.target.classList.add("active");
        // });
        // buttons__type[1].addEventListener("click", () => {
        //     event.target.classList.add("active");
        // }); 
        // buttons__type[2].addEventListener("click", () => {
        //     event.target.classList.add("active");
        // });
        // buttons__type[3].addEventListener("click", () => {
        //     event.target.classList.add("active");
        // });
        // if(this.isAmbassador) {
        //     buttons__type[4].addEventListener("click", () => {
        //         event.target.classList.add("active");
        //     });
        // }
        this.handleData();
        this.handleData(null, 1, 100, true)
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$primary: var(--theme-color-primary);
@mixin h4Title {
    text-transform: uppercase;
    color: $primary;
    position: relative;
    text-align: center;
    margin-bottom: 3rem;
}
.title__rank {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    .helper__tooltip::after {
        top: -8px;
    }
}
.all__values {
    margin-top: 1.5rem;
    .card-v4 {
        padding: 1rem;
        margin-bottom: 0;
        border-radius: 0;
        border-bottom: 0;
    }
    .options {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        border: 0.5px solid rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        padding: 0.5rem;
        margin-top: 35px;
        a {
            background: #fbfbfb;
            border-radius: 4px;
            padding: 1rem 2rem;
            color: rgba(112, 112, 112, 0.5);
            text-align: center;
            font-weight: bold;
            margin: 0.2rem 0;
            font-size: 0.9rem;
            transition: 0.2s all ease;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            &.active,
            &:hover {
                background: var(--theme-color-accent);
                color: white;
            }
        }
    }
    .container__grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        & > div {
            .box__in {
                border: 0.5px solid rgba(0, 0, 0, 0.12);
                border-radius: 4px;
                padding: 1rem;
            }
            &:last-child {
                border-right: none;
            }
        }
        .earnings,
        .tier {
            h4 {
                @include h4Title;
                margin-bottom: 1rem;
            }
            .body {
                padding: 0.4rem 0;
                .body__leads {
                    position: relative;
                    margin-bottom: 1rem;
                    display: flex;
                    flex-direction: column;
                    &::before {
                        content: "";
                        position: absolute;
                        bottom: -10px;
                        width: 70%;
                        height: 1px;
                        background: #c6c6c6;
                        left: 0;
                        right: 0;
                        margin: 0 auto;
                    }
                    div {
                        display: flex;
                        justify-content: space-between;
                        padding: 0.6rem 0;
                        span {
                            font-size: 0.9rem;
                            font-weight: bold;
                            &:first-child {
                                text-transform: uppercase;
                                color: $primary;
                            }
                            &:last-child {
                                color: var(--theme-color-accent);
                            }
                        }
                    }
                }
                .body__values {
                    display: flex;
                    flex-direction: column;
                    div {
                        display: flex;
                        justify-content: space-between;
                        padding: 0.6rem 0;
                        border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
                        &:last-child {
                            border-bottom: none;
                        }
                        span {
                            font-size: 0.9rem;
                            font-weight: bold;
                            &:first-child {
                                text-transform: uppercase;
                                color: $primary;
                            }
                            &:last-child {
                                color: #0cad25;
                            }
                            &.btc__icon {
                                background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAyNCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjQgMTYuNkMyMS4yIDE1LjcgMjEuNyAxNCAyMS40IDExLjNDMjEuMSA3LjYgMTggNi4zIDEzLjkgNlYwLjIwMDAwMUwxMC43IDAuOTAwMDAyVjUuOUM5LjkgNS45IDkgNS45IDguMiA1LjlWMEw1IDAuNzk5OTk5VjZDMy44IDYgNC42IDYgMC43OTk5OTkgNkwwIDkuNEMyLjUgOS40IDIuNCA5LjIgMi43IDEwLjhWMjVDMi41IDI2LjMgMy4xIDI2LjEgMC45MDAwMDIgMjZMMCAyOS44QzUuOCAyOS44IDUgMjkuOCA1IDI5LjhWMzQuMkw4LjIgMzMuMlYyOS44QzkuMSAyOS44IDkuOSAyOS44IDEwLjcgMjkuOFYzNC4xTDEzLjkgMzMuMVYyOS42QzE5LjIgMjkuMyAyMy4xIDI4IDIzLjUgMjNDMjMuOSAxOS4xIDIyLjQgMTcuMyAxOS40IDE2LjZaTTguMyA5LjVDMTAuMSA5LjUgMTcuMSA4LjkgMTcuMSAxMi43QzE3LjEgMTYuMiAxMC4xIDE1LjggOC4zIDE1LjhWOS41Wk04LjMgMjUuOVYxOUMxMC40IDE5IDE4LjQgMTguNCAxOC40IDIyLjVDMTguNCAyNi40IDEwLjUgMjUuOSA4LjMgMjUuOVoiIGZpbGw9IiMwQ0FEMjUiLz4KPC9zdmc+);
                                padding-left: 20px;
                                background-size: 20px 14px;
                                background-repeat: no-repeat;
                            }
                        }
                    }
                }
            }
        }
        .tier__indirect {
            h4 {
                border: 0.5px solid rgba(0, 0, 0, 0.12);
                padding: 0.5rem 3rem 0.2rem 1rem;
                width: max-content;
                margin: 0 auto 8px auto;
                cursor: pointer;
                border-radius: 4px;
                transition: 0.3s all;
                background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS40MSA3LjQxTDYgMi44M0wxMC41OSA3LjQxTDEyIDZMNiAzLjI5MDE2ZS0wNkwxLjIzMjY2ZS0wNyA2TDEuNDEgNy40MVoiIGZpbGw9IiM3RTFBRkQiLz4KPC9zdmc+);
                background-repeat: no-repeat;
                background-position: 95% center;
                position: relative;
                &:hover {
                    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCIgZmlsbD0ibm9uZSIgc3R5bGU9IiYjMTA7ICAgIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7JiMxMDsiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEuNDEgNy40MUw2IDIuODNMMTAuNTkgNy40MUwxMiA2TDYgMy4yOTAxNmUtMDZMMS4yMzI2NmUtMDcgNkwxLjQxIDcuNDFaIiBmaWxsPSIjN0UxQUZEIi8+Cjwvc3ZnPg==);
                    .select__level {
                        display: flex;
                    }
                }
                .select__level {
                    position: absolute;
                    left: 9px;
                    display: none;
                    flex-direction: column;
                    background: white;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    border-radius: 4px;
                    z-index: 1;
                    width: 90%;
                    span {
                        // padding: 0.8rem 1.9rem;
                        padding: 0.8rem 0;
                        transition: 0.2s all;
                        &:hover {
                            background: rgba(102, 179, 255, 0.17);
                        }
                        &.active {
                            display: none;
                        }
                    }
                }
            }
        }
        .animation__loading {
            height: 30px;
            width: 30px;
            border-radius: 100%;
            border: 2px solid $primary;
            border-top-color: white;
            border-bottom-color: white;
            animation: rotation 0.9s linear infinite;
            display: flex;
            align-self: center;
            justify-self: center;
        }

        @keyframes rotation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
}
@media (max-width: 980px) {
    .all__values .container__grid {
        grid-template-columns: 1fr;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/allValuesUser.vue